import { getQuery, getQueryWithParams, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { GET_VIDEO_CALL_URL } from "src/components/graphql/GraphQLquery";
import { SEND_VIDEO_CALL_END_NOTIFICATION, SEND_VIDEO_CALL_START_NOTIFICATION, } from "src/components/graphql/GraphQLmutation";
import { snackbar } from "@mobiscroll/react5";

export async function sendVideoCallStartNotification(appointmentId) {
  try {
    const response = await postMutation(SEND_VIDEO_CALL_START_NOTIFICATION, appointmentId);

    if (typeof response === "undefined") {
      throw new Error("error", response);
    } else {
      if (
        response.data.sendVideoCallStartNotification.statusCode < 300 &&
        response.data.sendVideoCallStartNotification.statusCode >= 200
      ) {
        return true;
      } else {
        throw new Error(response);
      }
    }
  } catch (e) {
    snackbar({ message: e.message || "Error occured while Sending Notification. Try again", color: "danger", });
    console.error("Error at sendVideoCallStartNotification: ", e);
    return false;
  }
}


export async function sendVideoCallEndNotification(data) {
  try {
    const response = await postMutation(SEND_VIDEO_CALL_END_NOTIFICATION, data);

    if (typeof response === "undefined") {
      throw new Error("error", response);
    } else {
      if (
        response.data.sendVideoCallEndNotification.statusCode < 300 &&
        response.data.sendVideoCallEndNotification.statusCode >= 200
      ) {
        return true;
      } else {
        throw new Error(response);
      }
    }
  } catch (e) {
    snackbar({ message: e.message || "Error occured while Sending Notification. Try again", color: "danger", });
    console.error("Error at sendVideoCallEndNotification: ", e);
    return false;
  }
}


//fetch video call crentials from backend
export async function getVideoCallCredentials(data) {
  try {
    const response = await getQueryWithParams(GET_VIDEO_CALL_URL, { appointmentId: data }, true);

    if (response?.data?.getVideoCallUrl?.statusCode >= 200 &&
      response?.data?.getVideoCallUrl?.statusCode < 300) {
      return response.data.getVideoCallUrl.data;
      
    } else {
      throw new Error(response?.data?.getVideoCallUrl?.message || "Failed to get video call credentials");
    }
  } catch (e) {
    snackbar({ message: e.message || "Failed to initialize video call. Please try again.", color: "danger", });
    console.error("Error getting video call credentials: ", e);
    return null;
  }
}